import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "im-top",
  style: {"-webkit-app-region":"drag"}
}

import { getCurrentInstance, ref } from "vue";
const iconBig = "icon-v-yk_fangkuai";
const iconSmall = "icon-v-xiaoxitixingchuangkoudanchufangshi";

export default /*@__PURE__*/_defineComponent({
  __name: 'Top',
  setup(__props) {

const { proxy } = getCurrentInstance();
function min() {
  proxy.$winControl.default.min();
}
const icon = ref(iconSmall);

function max() {
  proxy.$winControl.default.max();
  icon.value =
    icon.value === iconBig
      ? "icon-v-xiaoxitixingchuangkoudanchufangshi"
      : iconBig;
}

function close() {
  proxy.$winControl.default.close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "javascript:void(0)",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (min())),
      style: {"-webkit-app-region":"no-drag"}
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("i", { class: "iconfont icon-v-24gl-minimization" }, null, -1)
    ])),
    _createElementVNode("a", {
      href: "javascript:void(0)",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (max())),
      style: {"-webkit-app-region":"no-drag"}
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["iconfont", icon.value])
      }, null, 2)
    ]),
    _createElementVNode("a", {
      href: "javascript:void(0)",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (close())),
      style: {"-webkit-app-region":"no-drag"}
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("i", { class: "iconfont icon-v-guanbi1" }, null, -1)
    ]))
  ]))
}
}

})